(() => {
  'use strict';

  const DEBUG = false;

  const PIN_TOP = 100;
  const START_DELAY = 100;

  if(window.innerWidth < 990) return;

  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  const SECTION_SEL = '.carousel-vertical-scroll-section';
  const WRAPPER_SEL = '.carousel-vertical-scroll__slider-wrapper';
  const CONTENT_SEL = '.carousel-vertical-scroll__content';

  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

  class VerticalToHorizontalScroller {
    constructor(section) {
      this.section = section;
      this.wrapper = section.querySelector(WRAPPER_SEL);
      this.content = section.querySelector(CONTENT_SEL);
      if (!this.wrapper || !this.content) return;

      this.maxX = 0;
      this.startY = 0;
      this.endY = 0;
      this.rafId = null;
      this.active = false;

      this.prev = {
        sectionHeight: this.section.style.height || '',
        sectionPosition: this.section.style.position || '',
        sectionOverflow: this.section.style.overflow || '',
        contentPosition: this.content.style.position || '',
        contentTop: this.content.style.top || '',
        contentZ: this.content.style.zIndex || '',
        contentHeight: this.content.style.height || '',
        wrapperBehavior: this.wrapper.style.scrollBehavior || ''
      };

      this._logged = false;

      this.measure();
    }

    resetStyles() {
      this.active = false;

      this.section.style.height = this.prev.sectionHeight;
      this.section.style.position = this.prev.sectionPosition;
      this.section.style.overflow = this.prev.sectionOverflow;

      this.content.style.position = this.prev.contentPosition;
      this.content.style.top = this.prev.contentTop;
      this.content.style.zIndex = this.prev.contentZ;
      this.content.style.height = this.prev.contentHeight;

      this.wrapper.style.scrollBehavior = this.prev.wrapperBehavior;
    }

    measure() {
      if (!DESKTOP_MQ.matches) {
        this.resetStyles();
        return;
      }

      const maxX = Math.max(0, this.wrapper.scrollWidth - this.wrapper.clientWidth);
      this.maxX = maxX;

      if (maxX <= 0) {
        this.resetStyles();
        return;
      }

      this.section.style.height = '';
      this.content.style.height = '';

      const contentHeightReal = Math.ceil(this.content.getBoundingClientRect().height);

      this.section.style.height = `${contentHeightReal + maxX + START_DELAY}px`;
      this.section.style.position = 'relative';
      this.section.style.overflow = 'visible';

      this.content.style.position = 'sticky';
      this.content.style.top = `${PIN_TOP}px`;
      this.content.style.zIndex = '1';
      this.content.style.height = '';

      const rect = this.section.getBoundingClientRect();
      const sectionTopAbs = rect.top + window.scrollY;

      this.startY = sectionTopAbs + START_DELAY;
      this.endY = this.startY + maxX;

      if (DEBUG) {
        console.log('[V2H] measure', {
          maxX,
          contentHeightReal,
          sectionTopAbs,
          startY: this.startY,
          endY: this.endY,
          PIN_TOP,
          START_DELAY
        });
      }
    }

    onScroll() {
      if (!DESKTOP_MQ.matches || this.maxX <= 0) return;
      if (this.rafId) return;

      this.rafId = requestAnimationFrame(() => {
        this.rafId = null;

        const y = window.scrollY;

        if (y <= this.startY) {
          this.deactivate();
          this.wrapper.scrollLeft = 0;

          if (DEBUG && !this._logged) {
            this._logged = true;
            console.log('[V2H] before start', { y, startY: this.startY });
          }
          return;
        }

        if (y >= this.endY) {
          this.deactivate();
          this.wrapper.scrollLeft = this.maxX;
          return;
        }

        this.activate();

        const t = (y - this.startY) / (this.endY - this.startY);
        this.wrapper.scrollLeft = clamp(t, 0, 1) * this.maxX;
      });
    }

    activate() {
      if (this.active) return;
      this.active = true;
      this.wrapper.style.scrollBehavior = 'auto';
    }

    deactivate() {
      if (!this.active) return;
      this.active = false;
      this.wrapper.style.scrollBehavior = this.prev.wrapperBehavior || '';
    }
  }

  let instances = [];

  function init() {
    if (DEBUG) console.log('[V2H] init');

    instances.forEach(i => i && i.resetStyles && i.resetStyles());
    instances = [];

    document.querySelectorAll(SECTION_SEL).forEach(section => {
      const inst = new VerticalToHorizontalScroller(section);
      if (inst && inst.wrapper) instances.push(inst);
    });

    instances.forEach(i => i.measure());
    instances.forEach(i => i.onScroll());
  }

  function onResize() {
    instances.forEach(i => i.measure());
    instances.forEach(i => i.onScroll());
  }

  window.addEventListener('scroll', () => instances.forEach(i => i.onScroll()), { passive: true });
  window.addEventListener('resize', onResize);

  window.addEventListener('load', () => {
    init();
    setTimeout(onResize, 250);
    setTimeout(onResize, 1000);
  });

  if (DESKTOP_MQ.addEventListener) DESKTOP_MQ.addEventListener('change', init);

  init();
})();